// extracted by mini-css-extract-plugin
module.exports = {"read-more-less":"ReadMoreLess_read-more-less__pIlDH","toggle-button":"ReadMoreLess_toggle-button__SmAX3"};